import { takeLatest, put } from 'redux-saga/effects';

import * as error from '../ui/error';
import { AUTH_AZURE_ERROR_CODE } from '../../constants';
import { actions as loginAzureActions } from './login-azure';
import { actions as authorizationAzureActions } from './authAzure';
import { getAuthAzureErrorMessage } from '../../utils/auth/getAuthAzureErrorMessage';
import { consts as authAzureExternalRedirectConsts } from './authAzureExternalRedirect';

const { NOT_CONFIRMED } = AUTH_AZURE_ERROR_CODE;

function* handleAuthAzureExternalRedirectWorker({ payload }) {
  const { intl, type, code, login, token } = payload;

  if (type === 'error') {
    yield put({
      type: error.consts.UPDATE,
      payload: {
        id: getAuthAzureErrorMessage(code, intl),
      },
      isStaticFlow: true,
      infoErrorIcon: code === NOT_CONFIRMED ? 'information' : null,
    });
  }

  if (type === 'success') {
    yield put(
      authorizationAzureActions.setCredentialForMfa({
        login,
        token,
      }),
    );

    yield put(loginAzureActions.send({ access_token: token }));
  }
}

export function* authAzureExternalRedirectSaga() {
  yield takeLatest(
    [authAzureExternalRedirectConsts.INIT],
    handleAuthAzureExternalRedirectWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/auth/authAzureExternalRedirectSaga.js